export { default as ContactIcon } from './contact.svg'
export { default as HospitalIcon } from './hospital.svg'
